export default {
  customers(state) {
    return state.customers
  },
}
